import { type GeoImage } from "@overmap-ai/common"
import { selectGeoImageById } from "@overmap-ai/core"
import { useImageViewer } from "@overmap-ai/forms"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo, useCallback } from "react"

import { LuIconWithWrapper } from "../../../../components/Icons/LuIconWithWrapper"
import { GeoImageIndexLabel } from "../../../../components/IndexLabels/GeoImageIndex"
import { modelIconMapping } from "../../../../mappings/icons"
import { sdk } from "../../../../sdk"
import { useAppSelector } from "../../../../store"

export const GeoImageMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: GeoImage["uuid"] }

	const geoImage = useAppSelector(selectGeoImageById(uuid))
	const openImageViewer = useImageViewer()

	const handleView = useCallback(async () => {
		if (!geoImage) return

		const fileUrl = await sdk.geoImages.getPresignedUrl(geoImage.uuid)
		const file = await sdk.files.fetchFileFromUrl(fileUrl, geoImage.file_sha1, geoImage.file_name)

		openImageViewer((close) => ({
			file: file,
			onClose: close,
		}))
	}, [geoImage, openImageViewer])

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1 align-bottom"
			as="span"
		>
			{!!geoImage && (
				<span onClick={handleView} className="whitespace-nowrap">
					<LuIconWithWrapper
						icon={modelIconMapping.camera}
						background={false}
						className="align-sub"
						color="var(--base-12)"
					/>
					<GeoImageIndexLabel geoImageId={geoImage.uuid} />
				</span>
			)}
		</NodeViewWrapper>
	)
})
GeoImageMentionComponent.displayName = "GeoImageMentionComponent"
